//Adding class to fixed header after scroll 
const appCTA = document.querySelector(".component-application-cta");


if(appCTA) {
  const offset = appCTA.offsetTop;
  const rect   = appCTA.getBoundingClientRect();
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  let lastScroll = 0;
  // Create the function to be called on scroll
  const stick = function () {

    // Get the scroll
    let scroll = window.scrollY;
    
    if ( scroll >= offset) {
      appCTA.classList.add('stick');
    } else if (scroll <= offset){
      appCTA.classList.remove('stick');
    }
    
    if (scroll <= offset) {
      appCTA.classList.remove(scrollUp);
      appCTA.classList.remove(scrollDown);
      return;
    }
    
    if (scroll > lastScroll && !appCTA.classList.contains(scrollDown)) {
      // down
      appCTA.classList.remove(scrollUp);
      appCTA.classList.add(scrollDown);
    } else if (scroll < lastScroll && appCTA.classList.contains(scrollDown)) {
      // up
      appCTA.classList.remove(scrollDown);
      appCTA.classList.add(scrollUp);
    }
    lastScroll = scroll;
  };
  // listen to the scroll
  window.addEventListener('scroll', stick);
}